import { render, staticRenderFns } from "./FabricPairingDisclaimer.vue?vue&type=template&id=58725b4f&"
import script from "./FabricPairingDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./FabricPairingDisclaimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports